export enum FontStyle {
  Italic = 'italic',
  Normal = 'normal',
}

export enum FontWeight {
  Bold = 'bold',
  Normal = 'normal',
}

export enum TextDecoration {
  Underline = 'underline',
  Normal = 'normal',
}

export enum TextAlign {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}

/** 文本输入宽高适配方式 */
export enum TextResize {
  /** 自动适配宽度 */
  AutoWidth = 'auto_width',
  /** 自动适配高度 */
  AutoHeight = 'auto_height',
  /** 固定宽度 */
  Fixed = 'fixed',
  /** 自动适配宽高 */
  AutoWidthHeight = 'auto_width_height',
}
